import React, { useEffect } from "react";
import {
  changeSettingsObjectUuid,
  ChangeSettingsSectionParam,
  removeViewSettingsParam,
} from "src/app/SettingsModal/methods";

import { RootState } from "src/redux/reducers";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { CreatorContentMonitoringDetails } from "./components/CreatorContentMonitoringDetails/CreatorContentMonitoringDetails";
import { CreatorContentMonitoringList } from "./components/CreatorContentMonitoringList/CreatorContentMonitoringList";
import { getTeamsForWorkspace } from "src/redux/main/mainActions";

import "./CreatorContentMonitoring.scss";

interface Props {
  onClose: () => void;
  setExtensionsSection: (section: ChangeSettingsSectionParam) => void;
}

export const CreatorContentMonitoring = (props: Props) => {
  const { onClose, setExtensionsSection } = props;

  const { settingsModalData, activeWorkspaceUuid } = useSelector(
    (state: RootState) => state.mainReducer,
  );

  const { objectUuid } = settingsModalData;

  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getTeamsForWorkspace(activeWorkspaceUuid));
  }, [activeWorkspaceUuid, dispatch]);

  const closeDetailsView = () => {
    removeViewSettingsParam(history, "objectUuid");
  };

  const openContentMonitoringDetails = (uuid: string) => {
    changeSettingsObjectUuid(history, uuid);
  };

  const createNewContentMonitoring = () => {
    changeSettingsObjectUuid(history, "create-new");
  };

  const renderContent = () => {
    if (objectUuid) {
      return (
        <CreatorContentMonitoringDetails
          onClose={onClose}
          setExtensionsSection={setExtensionsSection}
          closeDetailsView={closeDetailsView}
        />
      );
    }

    return (
      <CreatorContentMonitoringList
        onClose={onClose}
        setExtensionsSection={setExtensionsSection}
        openContentMonitoringDetails={openContentMonitoringDetails}
        createNewContentMonitoring={createNewContentMonitoring}
      />
    );
  };

  return renderContent();
};
